module.exports = __webpack_public_path__ + "static/media/ic-imagem.885f302c.svg";